// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__yXgp2","file":"styles_file__1fbUL"};